import Typography from '@alltrails/core/components/Typography';
import Button from '@alltrails/denali/components/Button';
import Heading from '@alltrails/denali/components/Heading';
import LoadingDots from '@alltrails/denali/components/LoadingDots';
import SectionMessage from '@alltrails/denali/components/SectionMessage';
import PageUISectionList, { type PageUISectionComponents } from '@alltrails/layout/components/PageUI/PageUISectionList/PageUISectionList';
import type useAskResponse from '@/hooks/useAskResponse';
import type { AskAllTrailsRequest } from '@/utils/askAllTrailsApi';
import { useAppDispatch } from '@/utils/redux';
import { askQuestion } from '@/utils/slices/askSlice';
import styles from './AskSidebar.module.scss';

// Ask reads like search: insights sit right under their trail's card, so the lines between trails go
const sectionComponents: PageUISectionComponents = { divider: () => null };

type Props = Omit<ReturnType<typeof useAskResponse>, 'request'> & {
  request: AskAllTrailsRequest;
};

/**
 * The submitted question as the title, then the answer, or where the request is up to.
 */
const AskResponse = ({ error, isFetching, page, request }: Props) => {
  const dispatch = useAppDispatch();

  const loadingLabel = 'Searching trails and reviews…'; // hwandrew TODO: XPLR-204 translations
  const genericErrorMessage = 'Something went wrong. Please try again.'; // hwandrew TODO: XPLR-204 translations
  const retryLabel = 'Try again'; // hwandrew TODO: XPLR-204 translations

  return (
    <div className={styles.response}>
      <Heading as="h3" className={styles.question} size="300">
        {request.query}
      </Heading>
      {isFetching && (
        <div className={styles.loading} role="status">
          <LoadingDots />
          <Typography component="span" variant="text200">
            {loadingLabel}
          </Typography>
        </div>
      )}
      {error && (
        <div className={styles.error}>
          <SectionMessage text={error.message ?? genericErrorMessage} variant="error" />
          {error.canRetry && (
            <Button onClick={() => dispatch(askQuestion({ location: request.location, question: request.query }))} size="md" text={retryLabel} />
          )}
        </div>
      )}
      {page && <PageUISectionList components={sectionComponents} insightsInTrailResults page={page} />}
    </div>
  );
};

export default AskResponse;
